import RudderAnalyticsService from '../services/RudderAnalyticsService'

export const handlerSubmitScreen = screenID => {
  switch (screenID) {
    case 'HEALTH_DECLARATION_SUBMIT':
      RudderAnalyticsService.trackSubmitSuccessScreen()
      break

    default:
      break
  }
}
